import { API_BASE } from "./config/api";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";



export default function SchemeTypeMapping() {
  const [rawTypes, setRawTypes] = useState([]);
  const [mappings, setMappings] = useState({});
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE}/get_raw_scheme_types.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setRawTypes(data.raw_scheme_types);
        }
      });

    fetch(`${API_BASE}/get_scheme_type_mappings.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          // make object for easy editing
          const obj = {};
          data.mappings.forEach((m) => {
            obj[m.raw_scheme_type] = m.scheme_type;
          });
          setMappings(obj);
        }
      });
  }, []);

  const handleChange = (raw, value) => {
    setMappings((prev) => ({ ...prev, [raw]: value }));
  };

  const handleSaveAll = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE}/save_scheme_type_mapping.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mappings }),
      });
      const data = await res.json();
      if (data.status === "success") {
        alert("✅ All mappings saved successfully!");
        // Auto redirect to dashboard
        navigate("/dashboard");
      } else {
        alert("❌ " + data.message);
      }
    } catch (err) {
      alert("❌ " + err);
    }
    setSaving(false);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Scheme Type Mapping</h2>

      {/* Back Button */}
      <button
        onClick={() => navigate(-1)} // go back to previous page
        style={{
          marginBottom: 12,
          padding: "6px 14px",
          background: "#f0f0f0",
          border: "1px solid #ccc",
          borderRadius: 6,
          cursor: "pointer",
        }}
      >
        ← Back
      </button>

      <table
        border="1"
        cellPadding="6"
        style={{ borderCollapse: "collapse", width: "100%" }}
      >
        <thead style={{ background: "#eee" }}>
          <tr>
            <th>Raw Scheme Type</th>
            <th>Mapped Scheme Type</th>
          </tr>
        </thead>
        <tbody>
          {rawTypes.map((raw) => (
            <tr key={raw}>
              <td>{raw}</td>
              <td>
                <select
                  value={mappings[raw] || ""}
                  onChange={(e) => handleChange(raw, e.target.value)}
                  style={{ width: "100%", padding: "4px" }}
                >
                  <option value="">-- Select --</option>
                  <option value="EQUITY">EQUITY</option>
                  <option value="DEBT">DEBT</option>
                  <option value="HYBRID">HYBRID</option>
                  <option value="OTHERS">OTHERS</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button
        onClick={handleSaveAll}
        disabled={saving}
        style={{
          marginTop: 16,
          padding: "8px 20px",
          background: "#1677ff",
          color: "#fff",
          border: "none",
          borderRadius: 6,
          cursor: "pointer",
        }}
      >
        {saving ? "Saving..." : "Save All Mappings"}
      </button>
    </div>
  );
}
